import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';

@Pipe({
  name: 'emptyToNotAvailable',
})
export class EmptyToNotAvailablePipe implements PipeTransform {
  transform(value: string | number | null): string | number {
    return isNil(value) || value === '' ? NOT_AVAILABLE : value;
  }
}
